// eslint-disable-next-line no-restricted-imports
import { FormControl as ArcFormControl } from 'arc';
import { forwardRef, ForwardedRef, ReactElement, ComponentProps } from 'react';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const FormControl = forwardRef(function FormControl(
    props: ComponentProps<typeof ArcFormControl>,
    ref: ForwardedRef<HTMLDivElement>
): ReactElement {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize);
    return <ArcFormControl ref={ref} size={size} {...otherProps} />;
});
